import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-restore-password-view',
  templateUrl: './restore-password-view.component.html',
  styleUrls: ['./restore-password-view.component.css'],
})
export class RestorePasswordViewComponent implements OnInit {
  key: string;
  constructor(private _activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.key = this._activatedRoute.snapshot.params.key;
  }
}
